var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#0E88FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0423 6.66797H8.95898L7.91732 7.91797H6.66732C6.4463 7.91797 6.23434 8.00577 6.07806 8.16205C5.92178 8.31833 5.83398 8.53029 5.83398 8.7513V12.5013C5.83398 12.7223 5.92178 12.9343 6.07806 13.0906C6.23434 13.2468 6.4463 13.3346 6.66732 13.3346H13.334C13.555 13.3346 13.767 13.2468 13.9232 13.0906C14.0795 12.9343 14.1673 12.7223 14.1673 12.5013V8.7513C14.1673 8.53029 14.0795 8.31833 13.9232 8.16205C13.767 8.00577 13.555 7.91797 13.334 7.91797H12.084L11.0423 6.66797Z",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.668C10.6904 11.668 11.25 11.1083 11.25 10.418C11.25 9.72761 10.6904 9.16797 10 9.16797C9.30964 9.16797 8.75 9.72761 8.75 10.418C8.75 11.1083 9.30964 11.668 10 11.668Z",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineEvent);
export default __webpack_public_path__ + "static/media/timeline_event.ba0586e4343fd7068631d9d530bb930d.svg";
export { ForwardRef as ReactComponent };